import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-rounded-xl tw-overflow-hidden tw-pb-[30px]" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold tw-text-left" }, " CUSTOMER ", -1)
const _hoisted_3 = { class: "tw-px-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-font-bold tw-text-[#545454] tw-opacity-100 tw-border tw-border-b-[#545454] tw-border-t-0 tw-border-r-0 tw-border-l-0 tw-pb-1 tw-mt-7 tw-text-left" }, " PERSONAL DATA ", -1)
const _hoisted_5 = { class: "tw-flex tw-justify-between tw-items-center tw-mt-3 tw-gap-5 tw-text-left" }
const _hoisted_6 = { class: "tw-w-full" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "NAME", -1)
const _hoisted_8 = { class: "tw-w-full" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "PHONE NUMBER", -1)
const _hoisted_10 = { class: "tw-w-full" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "EMAIL", -1)

import { toRefs } from 'vue';
  
export default /*#__PURE__*/_defineComponent({
  __name: 'Customer',
  props: {
    customer: {
      type: Object,
      default: {
        name: '',
        phone: '',
        email: ''
      }
    }
  },
  setup(__props) {

const props = __props;

  
  const {customer} = toRefs(props)
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _withDirectives(_createElementVNode("input", {
            name: "",
            id: "",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(customer).name) = $event)),
            class: "tw-w-full tw-outline-none tw-h-[45px] tw-border tw-border-[#b6b6b6] tw-rounded-lg tw-overflow-hidden tw-px-4 tw-mt-0.5"
          }, null, 512), [
            [_vModelText, _unref(customer).name]
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _withDirectives(_createElementVNode("input", {
            name: "",
            id: "",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(customer).phone) = $event)),
            class: "tw-w-full tw-outline-none tw-h-[45px] tw-border tw-border-[#b6b6b6] tw-rounded-lg tw-overflow-hidden tw-px-4 tw-mt-0.5"
          }, null, 512), [
            [_vModelText, _unref(customer).phone]
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _withDirectives(_createElementVNode("input", {
            name: "",
            id: "",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(customer).email) = $event)),
            class: "tw-w-full tw-outline-none tw-h-[45px] tw-border tw-border-[#b6b6b6] tw-rounded-lg tw-overflow-hidden tw-px-4 tw-mt-0.5"
          }, null, 512), [
            [_vModelText, _unref(customer).email]
          ])
        ])
      ])
    ])
  ]))
}
}

})